import { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import ModelButton from "../modelBtn/modelButton";
import Gem from "./360Gem";
import { PropTypes } from 'prop-types';
import { DecodeHtml } from "../../utils/decodeHtml";
import { retrunAssets } from "../../utils/getAssets";
const InternationalCooperation = ({ internationalOffice }) => {


    const title = internationalOffice?.Section3title
    const subheader1 = internationalOffice?.subheader1
    const subDescription1 = DecodeHtml({ html: internationalOffice?.subDescription1?.markup })

    const subheader2 = internationalOffice?.subheader2
    const subDescription2 = DecodeHtml({ html: internationalOffice?.subDescription2?.markup })

    const img = internationalOffice?.section3Image != null ? retrunAssets(internationalOffice?.section3Image[0]?.url) : ""

    const whatWeDo = DecodeHtml({ html: internationalOffice?.description?.markup })

    const [modalOpen, setModalOpen] = useState(false);

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);

    return (
        <div className="bg-white flex flex-col w-full justify-center p-4 lg:p-8 2xl:p-16 2xl:px-24">
            <div className="flex flex-col items-center gap-8 w-full">
                <h1 className="w-auto text-2xl font-bold text-slate-900  2xl:text-5xl leading-tight">{title}</h1>
                <div className="flex flex-col self-start w-full gap-6 items-start">
                    <h2 className="w-auto text-2xl font-bold text-slate-900  2xl:text-3xl leading-tight">{subheader1}</h2>
                    <p className="w-auto  text-justify  whitespace-pre-line text-base font-normal leading-normal">{subDescription1}</p>
                </div>
                <div className="flex flex-col self-start w-full max-w-4xl gap-6 items-start">
                    <h2 className="w-auto text-2xl font-bold text-slate-900  2xl:text-3xl leading-tight">{subheader2}</h2>
                    <p className="w-auto text-justify   text-base font-normal leading-normal">{subDescription2}</p>
                </div>
                <div className="w-full grid grid-cols-1 self-start place-items-center md:place-items-start  md:grid-cols-[30%_65%] gap-10">
                    <div className="w-full max-w-[30rem] h-[20rem] bg-center rounded-lg  bg-cover bg-no-repeat" style={{ backgroundImage: `url('${img}')` }} />
                    <p className='whitespace-pre-line w-full'>
                    {
                        whatWeDo
                    }
                    </p>
                </div>

            </div>
            <div className="flex items-center justify-center  p-4  shadow-[0px_-100px_52px_47px_rgba(255,255,255,0.5)] w-full mt-4">
                <div className="flex flex-col items-center  justify-center gap-1 w-fit cursor-pointer"
                    onClick={() => (modalOpen ? closed() : open())}
                >
                    <h2 className="w-auto text-2xl font-bold text-slate-900  2xl:text-3xl leading-tight uppercase">{`See more`}</h2>
                    <IoIosArrowDown size={30} />
                </div>
                <ModelButton modalOpen={modalOpen} close={closed}>
                    <Gem internationalOffice={internationalOffice} />
                </ModelButton>
            </div>
        </div>
    )
}
InternationalCooperation.propTypes = {
    internationalOffice: PropTypes.object
}
export default InternationalCooperation